import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  lang: string = 'cn';
  loaded: boolean = false;
  about_cn = [''];
  about_en = [''];

  constructor(private data: DataService) { 
    data.getAboutDB().subscribe(list => {
      list.forEach(item => {
        if(item.key === 'about_cn') {
          this.about_cn[0] = item.payload.val();
        }
        else if(item.key === 'about_en') {
          this.about_en[0] = item.payload.val();
        }
      })

      this.loaded = true;
      this.about_cn = this.about_cn[0].split('\n');
      this.about_en = this.about_en[0].split('\n');
    });
  }

  ngOnInit() {
  }

  toggleLang(){
    if(this.lang === 'cn'){
      this.lang = 'en';
    }
    else {
      this.lang = 'cn';
    }
  }

}
